var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.elementType,
    {
      tag: "div",
      staticClass: "button",
      class: _vm.modifierClasses,
      style: _vm.buttonStyles,
      attrs: { href: _vm.buttonHref, disabled: _vm.isDisabled, tabindex: "0" },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.clickAction.apply(null, arguments)
        }
      }
    },
    [
      _c("span", { staticClass: "u-sr-only" }, [_vm._v(_vm._s(_vm.label))]),
      _vm.iconName
        ? _c("icon", {
            staticClass: "button__icon",
            attrs: {
              name: _vm.iconName,
              size: _vm.iconSize,
              mobileSize: _vm.iconSizeMobile,
              width: _vm.iconWidth,
              height: _vm.iconHeight
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "button__content" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }